/**
 * The save function defines the way in which the different attributes should be combined
 * into the final markup, which is then serialized by the block editor into `post_content`.
 *
 * @return {null} This is a dynamic block.
 */
export default function save() {
    return null;
}
